const styleMatcher = [
  "BE1-FLEX 000002","BE1-FLEX K-T3N0N0N0-W9-E5-1N1-B02N-00",
  "BE1-FLEX 000003","BE1-FLEX K-T3L6N0N0-W9-E5-1N1-B02N-00",
  "BE1-FLEX 000004","BE1-FLEX K-T3L6N0A2-W9-E5-1N1-B02N-00",
  "BE1-FLEX 000005","BE1-FLEX K-T3X6C5N5-W9-W2-2N0-B01N-00", 
  "BE1-FLEX 000006","BE1-FLEX K-M0L2A2U4-W9-G3-2N0-B01N-00", 
  "BE1-FLEX 000007","BE1-FLEX K-N0N0N0N0-N5-W2-2N0-B01N-00", 
  "BE1-FLEX 000008","BE1-FLEX K-N0N0N0N5-W9-W2-2N0-B01N-00", 
  "BE1-FLEX 000009","BE1-FLEX K-N0N0N0N0-N0-N0-1N0-B01N-00", 
  "BE1-FLEX 000010","BE1-FLEX K-N0N0N0N0-N0-N0-2N0-B01N-00", 
  "BE1-FLEX 000011","BE1-FLEX K-N0N0N0N0-N0-N0-3N0-B01N-00", 
  "BE1-FLEX 000012","BE1-FLEX K-N0N0N0N0-N5-W2-1N0-B01N-00",
  "BE1-FLEX 000013","BE1-FLEX K-X6X9C5N5-W9-W2-2N1-E01N-00", 
  "BE1-FLEX 000014","BE1-FLEX K-M0A9A2U4-W9-G3-2N1-E01N-00",
  "BE1-FLEX 000015","BE1-FLEX K-L6N0N0N0-N0-E5-1N1-B01N-00", 
  "BE1-FLEX 000016","BE1-FLEX K-L6N0N0N0-N0-E5-2N1-B01N-00", 
  "BE1-FLEX 000017","BE1-FLEX K-L6N0N0N0-N0-E5-3N1-B01N-00", 
  "BE1-FLEX 000018","BE1-FLEX K-L6N0N0N0-N0-E5-1N1-B00N-00", 
  "BE1-FLEX 000019","BE1-FLEX K-L6N0N0N0-N0-E5-2N1-B00N-00", 
  "BE1-FLEX 000020","BE1-FLEX K-L6N0N0N0-N0-E5-3N1-B00N-00", 
  "BE1-FLEX 000021","BE1-FLEX K-X9N0N0N0-N0-E5-1N1-C01N-00", 
  "BE1-FLEX 000022","BE1-FLEX K-X9N0N0N0-N0-E5-2N1-C01N-00", 
  "BE1-FLEX 000023","BE1-FLEX K-X9N0N0N0-N0-E5-3N1-C01N-00", 
  "BE1-FLEX 000024","BE1-FLEX K-X9N0N0N0-N0-E5-1N1-C00N-00", 
  "BE1-FLEX 000025","BE1-FLEX K-X9N0N0N0-N0-E5-2N1-C00N-00", 
  "BE1-FLEX 000026","BE1-FLEX K-X9N0N0N0-N0-E5-3N1-C00N-00", 
  "BE1-FLEX 000027","BE1-FLEX K-T3N0N0N0-N0-E5-1N1-B01N-00", 
  "BE1-FLEX 000028","BE1-FLEX K-T3N0N0N0-N0-E5-2N1-B01N-00", 
  "BE1-FLEX 000029","BE1-FLEX K-T3N0N0N0-N0-E5-3N1-B01N-00", 
  "BE1-FLEX 000030","BE1-FLEX K-T3X6N0C5-N5-E5-1N1-E01N-00", 
  "BE1-FLEX 000031","BE1-FLEX K-T3X6N0C5-N5-E5-2N1-E01N-00", 
  "BE1-FLEX 000032","BE1-FLEX K-T3X6L6C5-N5-E5-1N1-E01N-00", 
  "BE1-FLEX 000033","BE1-FLEX K-T3X6L6C5-N5-E5-2N1-E01N-00", 
  "BE1-FLEX 000034","BE1-FLEX K-T3N0N0N0-W9-E5-1N1-D00N-00", 
  "BE1-FLEX 000035","BE1-FLEX K-T3N0N0N0-W9-E5-2N1-D00N-00", 
  "BE1-FLEX 000036","BE1-FLEX K-T3N0N0N0-W9-E5-3N1-D00N-00", 
  "BE1-FLEX 000037","BE1-FLEX K-T3N0N0N0-W9-E5-1N1-D01N-00", 
  "BE1-FLEX 000038","BE1-FLEX K-T3N0N0N0-W9-E5-2N1-D01N-00", 
  "BE1-FLEX 000039","BE1-FLEX K-T3N0N0N0-W9-E5-3N1-D01N-00", 
  "BE1-FLEX 000040","BE1-FLEX K-T3N0N0N0-W9-P7-1N1-D01N-00", 
  "BE1-FLEX 000041","BE1-FLEX K-T3N0N0N0-W9-P7-2N1-D01N-00", 
  "BE1-FLEX 000042","BE1-FLEX K-T3N0N0N0-W9-P7-3N1-D01N-00", 
  "BE1-FLEX 000043","BE1-FLEX K-T3L6N0N0-W9-E5-1N1-E01N-00", 
  "BE1-FLEX 000044","BE1-FLEX K-T3L6N0N0-W9-E5-2N1-E01N-00", 
  "BE1-FLEX 000045","BE1-FLEX K-T3L6N0N0-W9-P7-1N1-E01N-00", 
  "BE1-FLEX 000046","BE1-FLEX K-T3L6N0N0-W9-P7-2N1-E01N-00", 
  "BE1-FLEX 000047","BE1-FLEX K-T3N0N0N0-W9-E5-1N0-D00N-00", 
  "BE1-FLEX 000048","BE1-FLEX K-T3N0N0N0-W9-E5-2N0-D00N-00", 
  "BE1-FLEX 000049","BE1-FLEX K-T3N0N0N0-W9-E5-3N0-D00N-00", 
  "BE1-FLEX 000050","BE1-FLEX K-T3N0N0N0-W9-E5-1N0-D01N-00", 
  "BE1-FLEX 000051","BE1-FLEX K-T3N0N0N0-W9-E5-2N0-D01N-00", 
  "BE1-FLEX 000052","BE1-FLEX K-T3N0N0N0-W9-E5-3N0-D01N-00", 
  "BE1-FLEX 000053","BE1-FLEX K-T3N0N0N0-W9-P7-1N0-D01N-00", 
  "BE1-FLEX 000055","BE1-FLEX K-T3N0N0N0-W9-P7-3N0-D01N-00", 
  "BE1-FLEX 000056","BE1-FLEX K-T3L6N0N0-W9-E5-1N0-E01N-00", 
  "BE1-FLEX 000057","BE1-FLEX K-T3L6N0N0-W9-E5-2N0-E01N-00", 
  "BE1-FLEX 000058","BE1-FLEX K-T3L6N0N0-W9-P7-1N0-E01N-00", 
  "BE1-FLEX 000059","BE1-FLEX K-T3L6N0N0-W9-P7-2N0-E01N-00", 
  "BE1-FLEX 000060","BE1-FLEX K-T3N0N0N0-W9-P7-2N0-D01N-00", 
  "BE1-FLEX 000061","BE1-FLEX K-T3L2A2U4-W9-G3-1N1-E01N-00", 
  "BE1-FLEX 000062","BE1-FLEX K-M0X6A2U4-W9-W2-1N1-E01N-00", 
  "BE1-FLEX 000063","BE1-FLEX K-T3A9A2U4-W9-H7-1N1-E01N-00", 
  "BE1-FLEX 000064","BE1-FLEX K-T3L6N0N5-W9-E5-1N1-E01N-00", 
  "BE1-FLEX 000065","BE1-FLEX K-T3X9N0C5-W9-W2-1N1-E01N-00", 
  "BE1-FLEX 000066","BE1-FLEX K-T3L6N0N0-W9-H8-1N1-E01N-00", 
  "BE1-FLEX 000067","BE1-FLEX K-T3L6N0N0-W9-W2-2N0-D00N-00",
  "BE1-FLEX 000068","BE1-FLEX K-T3L6N0N0-W9-W2-3N1-C01N-00", 
  "BE1-FLEX 000069","BE1-FLEX K-T3L6N0N0-W9-W2-1N1-B01N-00", 
  "BE1-FLEX 000070","BE1-FLEX K-T3L6N0N0-W9-W2-1N1-A01N-00", 
  "BE1-FLEX 000071","BE1-FLEX K-T3L6N0N0-W9-W2-1N1-E01N-00",
  "BE1-FLEX 000072","BE1-FLEX K-M0N0C5N5-W9-E5-3N1-E01N-00",
  "BE1-FLEX 000073","BE1-FLEX K-T3T3C5U4-W9-G3-3N0-E01N-00",
  "BE1-FLEX 000074","BE1-FLEX K-T3L6A2C5-W9-E5-1N1-E01N-00", 
  "BE1-FLEX 000075","BE1-FLEX K-T3T3N0C5-N5-P7-1N0-A01N-00",
  "BE1-FLEX 000076","BE1-FLEX K-L6N0N0N0-W9-N0-1N0-B00N-00", 
  "BE1-FLEX 000077","BE1-FLEX K-X6X9W9W9-W9-H7-3N1-E01N-00",
  "BE1-FLEX 000078","BE1-FLEX K-X6X9A2W9-W9-H7-3N1-E01N-00", 
  "BE1-FLEX 000079","BE1-FLEX K-T3A9A2U4-W9-W2-1N1-E01N-00", 
  "BE1-FLEX 000080","BE1-FLEX K-T3N0N0U4-W9-W2-3N0-D01N-00",
  "BE1-FLEX 000081","BE1-FLEX K-T3X6X6X6-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000082","BE1-FLEX K-X9N0N0N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000083","BE1-FLEX K-T3A2C5U4-W9-H7-2N1-E01N-00",
  "BE1-FLEX 000084","BE1-FLEX K-T3N0N0N0-W9-W9-1N0-A00N-00",
  "BE1-FLEX 000085","BE1-FLEX K-T3N0N0N0-W9-H7-1N0-A00N-00",
  "BE1-FLEX 000086","BE1-FLEX K-T3N0N0A2-W9-H7-1N0-D01N-00",
  "BE1-FLEX 000087","BE1-FLEX K-T3A2C5U4-W9-W2-2N1-E01N-00",
  "BE1-FLEX 000088","BE1-FLEX K-T3T3N0W9-W9-H7-1N0-E01N-00",
  "BE1-FLEX 000089","BE1-FLEX K-T3N0N0C5-W9-E5-3N0-D00N-00",
  "BE1-FLEX 000090","BE1-FLEX K-T3X9N0C5-N5-E5-1N0-E01N-00",
  "BE1-FLEX 000091","BE1-FLEX K-T3T3L6N0-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000092","BE1-FLEX K-T3T3X9N0-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000093","BE1-FLEX K-T3X6L6N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000094","BE1-FLEX K-T3N0N0N0-W9-W2-1N0-A00N-00",
  "BE1-FLEX 000095","BE1-FLEX K-T3X9N0N0-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000096","BE1-FLEX K-T3T3A2W9-W9-E5-3N1-E01N-00",
  "BE1-FLEX 000097","BE1-FLEX K-L6N0N0N0-W9-E5-1N0-B01N-00",
  "BE1-FLEX 000098","BE1-FLEX K-T3N0A2U4-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000099","BE1-FLEX K-T3T3A2W9-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000100","BE1-FLEX K-X9N0N0N0-W9-E5-1N0-C01N-00",
  "BE1-FLEX 000101","BE1-FLEX K-T3C5U4W9-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000102","BE1-FLEX K-M0X6N0N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000103","BE1-FLEX K-L2X9A2C5-N5-E5-1N1-E01N-00",
  "BE1-FLEX 000104","BE1-FLEX K-T3N0N0N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000105","BE1-FLEX K-N0N0N0N0-W9-N0-1N0-D01N-00",
  "BE1-FLEX 000106","BE1-FLEX K-T3N0N0N0-W9-N0-1N0-D01N-00",
  "BE1-FLEX 000107","BE1-FLEX K-T3T3N0W9-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000108","BE1-FLEX K-T3L6N0N0-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000109","BE1-FLEX K-T3L6N0W9-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000110","BE1-FLEX K-T3X6L6C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000111","BE1-FLEX K-T3X6L6C5-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000112","BE1-FLEX K-T3N0N0W9-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000113","BE1-FLEX K-T3L6N0W9-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000114","BE1-FLEX K-T3T3N0C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000115","BE1-FLEX K-T3L6N0C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000116","BE1-FLEX K-T3L6N0C5-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000117","BE1-FLEX K-T3N0N0C5-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000118","BE1-FLEX K-T3T3A2C5-N5-W2-3N1-E01N-00",
  "BE1-FLEX 000119","BE1-FLEX K-T3T3L6W9-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000120","BE1-FLEX K-X6N0N0N0-W9-N0-2N1-B01N-00",
  "BE1-FLEX 000121","BE1-FLEX K-X6N0N0N0-W9-N0-2N1-E01N-00",
  "BE1-FLEX 000122","BE1-FLEX K-T3L6N0C5-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000123","BE1-FLEX K-N0N0N0N0-W9-N0-1N0-C00N-00",
  "BE1-FLEX 000124","BE1-FLEX K-T3N0N0N0-W9-N0-1N0-C00N-00",
  "BE1-FLEX 000125","BE1-FLEX K-T3L6N0C5-W9-E5-2N1-E01N-00",
  "BE1-FLEX 000126","BE1-FLEX K-T3N0N0N0-W9-E5-1N0-C01N-00",
  "BE1-FLEX 000127","BE1-FLEX K-T3T3C5N5-N5-E5-1N0-E01N-00",
  "BE1-FLEX 000128","BE1-FLEX K-T3N0N0N0-N0-E5-1N0-D01N-00",
  "BE1-FLEX 000129","BE1-FLEX K-T3T3C5N5-N5-E5-3N1-D01N-00",
  "BE1-FLEX 000130","BE1-FLEX K-T3L6C5C5-N5-C5-1N0-E00N-00",
  "BE1-FLEX 000131","BE1-FLEX K-X6L6N0N0-W9-N0-1N0-E00N-00",
  "BE1-FLEX 000132","BE1-FLEX K-T3T3X6X6-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000133","BE1-FLEX K-T3X9N0C5-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000134","BE1-FLEX K-T3N0N0N0-W9-E5-1N0-E00N-00",
  "BE1-FLEX 000135","BE1-FLEX K-T3C5U4N5-W9-W2-3N1-E01N-00",
  "BE1-FLEX 000136","BE1-FLEX K-T3L6N0N0-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000137","BE1-FLEX K-T3N0N0N0-W9-H7-1N0-D00N-00",
  "BE1-FLEX 000138","BE1-FLEX K-T3X6N0N0-W9-E5-2N0-E01N-00",
  "BE1-FLEX 000139","BE1-FLEX K-T3X9X9C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000140","BE1-FLEX K-T3T3N0C5-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000141","BE1-FLEX K-T3T3N0C5-N5-W2-1N0-E01N-00",
  "BE1-FLEX 000142","BE1-FLEX K-T3T3X6C5-N5-W2-1N0-E01N-00",
  "BE1-FLEX 000143","BE1-FLEX K-X9X9N0C5-W9-E5-1N0-E00N-00",
  "BE1-FLEX 000144","BE1-FLEX K-T3T3T3C5-N5-E5-3N0-E01N-00",
  "BE1-FLEX 000145","BE1-FLEX K-X6N0N0N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000146","BE1-FLEX K-X9N0N0N0-N0-E5-1N0-C00N-00",
  "BE1-FLEX 000147","BE1-FLEX K-X6N0N0N0-W9-E5-1N1-E01N-00",
  "BE1-FLEX 000148","BE1-FLEX K-T3L6A2C5-W9-W2-1N0-E01N-00",
  "BE1-FLEX 000149","BE1-FLEX K-X9C5C5N5-W9-N0-1N0-E00N-00",
  "BE1-FLEX 000150","BE1-FLEX K-T3X9N0N0-C5-E5-3N1-C01N-00",
  "BE1-FLEX 000151","BE1-FLEX K-T3L6N0N0-W9-W2-2N1-E01N-00",
  "BE1-FLEX 000152","BE1-FLEX K-T3L6A2C5-N5-G3-3N0-E01N-00",
  "BE1-FLEX 000153","BE1-FLEX K-T3N0A2C5-N5-G3-3N0-E01N-00",
  "BE1-FLEX 000154","BE1-FLEX K-W9W9W9W9-W9-H7-1N0-A01N-00",
  "BE1-FLEX 000155","BE1-FLEX K-T3L6W9W9-W9-P7-1N0-E01N-00",
  "BE1-FLEX 000156","BE1-FLEX K-T3X6X6X6-W9-W2-3N0-E01N-00",
  "BE1-FLEX 000157","BE1-FLEX K-N0N0N0N0-N0-N0-1N0-E01N-00",
  "BE1-FLEX 000158","BE1-FLEX K-N0N0N0N0-N0-N0-1N0-D01N-00",
  "BE1-FLEX 000159","BE1-FLEX K-X9X9N0C5-N5-E5-1N0-C01N-00",
  "BE1-FLEX 000160","BE1-FLEX K-T3N0N0W9-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000161","BE1-FLEX K-T3L6N0N0-W9-E5-3N1-E01N-00",
  "BE1-FLEX 000162","BE1-FLEX K-T3N0N0C5-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000163","BE1-FLEX K-T3N0N0N0-W9-N5-1N0-A00N-00",
  "BE1-FLEX 000164","BE1-FLEX K-T3N0N0N0-W9-E5-1N0-A00N-00",
  "BE1-FLEX 000165","BE1-FLEX K-T3N0N0C5-W9-E5-1N0-D00N-00",
  "BE1-FLEX 000166","BE1-FLEX K-T3N0A2C5-N5-G3-3N0-D01N-00",
  "BE1-FLEX 000167","BE1-FLEX K-X6N0N0W9-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000168","BE1-FLEX K-T3T3N0C5-W9-W2-1N0-E01N-00",
  "BE1-FLEX 000169","BE1-FLEX K-T3T3N0N0-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000170","BE1-FLEX K-T3T3L6W9-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000171","BE1-FLEX K-L2X9A2C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000172","BE1-FLEX K-T3L6N0U4-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000173","BE1-FLEX K-L6N0N0N0-W9-E5-3N0-B01N-00",
  "BE1-FLEX 000174","BE1-FLEX K-T3C5C5U4-W9-G3-3N0-E01N-00",
  "BE1-FLEX 000175","BE1-FLEX K-T3T3L6C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000176","BE1-FLEX K-T3X6L6A9-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000177","BE1-FLEX K-T3X9N0N0-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000178","BE1-FLEX K-X9X9X9W9-W9-C5-3N1-E00N-00",
  "BE1-FLEX 000179","BE1-FLEX K-X6X9N0N0-W9-E5-3N1-E01N-00",
  "BE1-FLEX 000180","BE1-FLEX K-T3M0C5U4-N5-E5-3N1-E01N-00",
  "BE1-FLEX 000181","BE1-FLEX K-T3M0N0A2-U4-E5-1N0-E01N-00",
  "BE1-FLEX 000182","BE1-FLEX K-T3N0N0C5-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000183","BE1-FLEX K-T3L6N0N0-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000184","BE1-FLEX K-T3T3N0N0-W9-E5-1N0-D01N-00",
  "BE1-FLEX 000185","BE1-FLEX K-T3X9N0C5-N5-E5-3N1-C01N-00",
  "BE1-FLEX 000186","BE1-FLEX K-T3N0N0N0-C5-H7-1N0-E01N-00",
  "BE1-FLEX 000187","BE1-FLEX K-T3N0N0N0-W9-H7-1N0-D01N-00",
  "BE1-FLEX 000188","BE1-FLEX K-M0N0N0N0-W9-N0-3N0-B00N-00",
  "BE1-FLEX 000189","BE1-FLEX K-L6N0N0N0-N0-E5-1N0-B00N-00",
  "BE1-FLEX 000190","BE1-FLEX K-T3N0N0N0-C5-E5-1N0-E00N-00",
  "BE1-FLEX 000191","BE1-FLEX K-L6X6N0C5-N5-E5-3N1-D00N-00",
  "BE1-FLEX 000192","BE1-FLEX K-M0N0N0U4-N5-G3-1N0-E01N-00",
  "BE1-FLEX 000193","BE1-FLEX K-T3T3T3C5-N5-H7-1N1-E00N-00",
  "BE1-FLEX 000194","BE1-FLEX K-T3L6L6W9-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000195","BE1-FLEX K-T3N0N0N0-W9-W2-3N0-D01N-00",
  "BE1-FLEX 000196","BE1-FLEX K-T3T3N0N0-C5-E5-1N0-E01N-00",
  "BE1-FLEX 000197","BE1-FLEX K-T3T3N0N0-W9-E5-3N0-D00N-00",
  "BE1-FLEX 000198","BE1-FLEX K-T3L6N0A2-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000199","BE1-FLEX K-T3T3X6C5-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000200","BE1-FLEX K-T3T3N0N0-W9-N0-3N0-D00N-00",
  "BE1-FLEX 000201","BE1-FLEX K-T3N0N0A2-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000202","BE1-FLEX K-X6X9N0A2-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000203","BE1-FLEX K-T3X6X6N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000204","BE1-FLEX K-L6N0N0N0-W9-N0-1N0-D00N-00",
  "BE1-FLEX 000205","BE1-FLEX K-T3T3A2W9-W9-E5-2N0-E01N-00",
  "BE1-FLEX 000206","BE1-FLEX K-T3T3N0N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000207","BE1-FLEX K-T3T3X9C5-N5-E5-1N0-E01N-00",
  "BE1-FLEX 000208","BE1-FLEX K-T3C5N5N5-N5-E5-3N0-E01N-00",
  "BE1-FLEX 000209","BE1-FLEX K-T3L6W9W9-W9-E5-1N0-E00N-00",
  "BE1-FLEX 000210","BE1-FLEX K-T3T3C5W9-W9-G3-3N0-D01N-00",
  "BE1-FLEX 000211","BE1-FLEX K-L6X9X9W9-W9-E5-1N0-D00N-00",
  "BE1-FLEX 000212","BE1-FLEX K-L2L2L6N0-N0-E5-1N0-E01N-00",
  "BE1-FLEX 000213","BE1-FLEX K-M0L6N0C5-C5-E5-1N0-E01N-00",
  "BE1-FLEX 000214","BE1-FLEX K-M0A9N0W9-C5-E5-1N0-E01N-00",
  "BE1-FLEX 000215","BE1-FLEX K-L2L6N0N0-N0-E5-1N0-E01N-00",
  "BE1-FLEX 000216","BE1-FLEX K-M0L6X9C5-C5-E5-1N0-E01N-00",
  "BE1-FLEX 000217","BE1-FLEX K-T3T3N0A2-W9-W2-1N0-D01N-00",
  "BE1-FLEX 000218","BE1-FLEX K-T3L6N0C5-W9-N0-1N0-E00N-00",
  "BE1-FLEX 000219","BE1-FLEX K-U4U4U4U4-U4-E5-1N0-D01N-00",
  "BE1-FLEX 000220","BE1-FLEX K-T3X6X6X9-W9-C5-1N0-E01N-00",
  "BE1-FLEX 000221","BE1-FLEX K-T3T3X9X9-W9-E5-3N0-D01N-00",
  "BE1-FLEX 000222","BE1-FLEX K-T3X6X6W9-W9-C5-1N0-E01N-00",
  "BE1-FLEX 000223","BE1-FLEX K-T3T3N0N0-W9-E5-3N0-E01N-00",
  "BE1-FLEX 000224","BE1-FLEX K-T3N0N0N0-N0-H7-1N0-C01N-00",
  "BE1-FLEX 000225","BE1-FLEX K-T3T3N0N0-C5-W2-3N1-E01N-00",
  "BE1-FLEX 000226","BE1-FLEX K-T3N0N0N0-W9-N0-1N0-D00N-00",
  "BE1-FLEX 000227","BE1-FLEX K-T3T3X9N0-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000228","BE1-FLEX K-T3N0N0N0-W9-N0-3N0-C00N-00",
  "BE1-FLEX 000229","BE1-FLEX K-X6X9N0A2-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000230","BE1-FLEX K-T3L6C5A2-N0-E5-1N0-E01N-00",
  "BE1-FLEX 000231","BE1-FLEX K-N0N0A2C5-N5-E5-1N0-B00N-00",
  "BE1-FLEX 000232","BE1-FLEX K-T3T3X6N5-C5-E5-1N0-E01N-00",
  "BE1-FLEX 000233","BE1-FLEX K-T3M0C5U4-N5-W2-1N0-E01N-00",
  "BE1-FLEX 000234","BE1-FLEX K-T3T3T3A2-W9-E5-1N0-A00N-00",
  "BE1-FLEX 000235","BE1-FLEX K-T3T3L6C5-N5-W2-1N0-E01N-00",
  "BE1-FLEX 000236","BE1-FLEX K-T3T3N0W9-W9-N0-1N0-D00N-00",
  "BE1-FLEX 000237","BE1-FLEX K-T3N0N0C5-N5-H7-1N0-D01N-00",
  "BE1-FLEX 000238","BE1-FLEX K-T3T3N0N0-W9-N0-3N0-E00N-00",
  "BE1-FLEX 000239","BE1-FLEX K-T3T3L6U4-W9-E5-1N0-E01N-00",
  "BE1-FLEX 000240","BE1-FLEX K-T3N0A2C5-N5-G3-3N0-D02N-00",
  "BE1-FLEX 000241","BE1-FLEX K-T3L6A2C5-N5-G3-3N0-E02N-00",
  "BE1-FLEX 000242","BE1-FLEX K-T3T3X6C5-W9-E5-1N1-E01N-00",
  "BE1-FLEX 000243","BE1-FLEX K-T3T3A2N5-N5-W2-3N0-D01N-00",
  "BE1-FLEX 000244","BE1-FLEX K-X9N0N0N0-C5-N0-1N0-C00N-00",
  "BE1-FLEX 000245","BE1-FLEX K-T3L6N0N0-W9-E5-1N0-E00N-00",
  "BE1-FLEX 000246","BE1-FLEX K-T3T3C5N5-N5-E5-3N0-E01N-00",
  "BE1-FLEX 000247","BE1-FLEX K-T3X9X9C5-W9-E5-1N1-E01N-00",
  "BE1-FLEX 000248","BE1-FLEX K-X6X9N0A2-W9-E5-1N1-E01N-00",
  "BE1-FLEX 000249","BE1-FLEX K-T3L6N0N0-W9-N0-3N0-D00N-00",
  "BE1-FLEX 000250","BE1-FLEX K-T3N0N0N0-N0-E5-3N0-C01N-00",
  "BE1-FLEX 000251","BE1-FLEX K-T3T3N0N0-N0-E5-3N0-E00N-00"
]

function validateStyle(caseSettings) {
  let valid = true;
  let groupArr = [];
  const maxSlots = caseSettings.cardSlots;
  let analogBoards = 0;
  let commBoards = 0;
  let ioBoards = 0;
  let powerBoards = 0;
  let errorString = "";
  let radioFlag = false;

  //Get all name attributes from the form elements
  document.querySelectorAll("#style-configurator input").forEach(element => {
    groupArr.push(element.name);
  })

  //Dedup name values
  groupArr = [...new Set(groupArr)]

  //loop through and validate each input group
  groupArr.forEach(group => {

    if (group === "analogBoards") {
      //Add up all analog boards and check against maximum allowed analog boards
      const max = caseSettings.analogMax;
      let boards = document.querySelectorAll("#style-configurator input[name=" + group + "]");

      boards.forEach(board => {
        analogBoards += parseInt(board.value);
      })

      if (analogBoards > max) {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "red";
        errorString += "Style Error: Too many analog boards have been added (" + analogBoards + "/" + max + ")<br/>"
        valid = false;
      } else {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "black";
      }

    } else if (group === "ioBoards") {
      //Add up all I/O boards and check against maximum allowed I/O boards
      const max = caseSettings.ioMax;
      let boards = document.querySelectorAll("#style-configurator input[name=" + group + "]");

      boards.forEach(board => {
        ioBoards += parseInt(board.value);
      })

      if (ioBoards > max) {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "red";
        errorString += "Style Error: Too many I/O boards have been added (" + ioBoards + "/" + max + ")<br/>"
        valid = false;
      } else {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "black";
      }

    } else if (group === "commBoards") {
      //Add up all communication boards and check against maximum allowed communication boards
      const max = caseSettings.commMax;
      let boards = document.querySelectorAll("#style-configurator input[name=" + group + "]");

      boards.forEach(board => {
        commBoards += parseInt(board.value);
      })

      if (commBoards > max) {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "red";
        errorString += "Style Error: Too many communication boards have been added (" + commBoards + "/" + max + ")<br/>"
        valid = false;
      } else {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "black";
      }

    } else {
      //check that of the radio buttons from the group has been selected
      if (document.querySelector("#style-configurator input[name=" + group + "]:checked") === null) {
        document.querySelector("#style-configurator #" + group + " h3").style.color = "red";
        radioFlag = true;
        valid = false;
      } else {
        if (group === "powerSupply") {
          powerBoards++;
        }

        document.querySelector("#style-configurator #" + group + " h3").style.color = "black";
      }
    }
  })

  if ((analogBoards + ioBoards + commBoards + powerBoards) > maxSlots) {
    errorString += "Style Error: Too many boards have been added (" + (analogBoards + ioBoards + commBoards + powerBoards) + "/" + maxSlots + ")<br/>"

    valid = false;
  } else {
    document.querySelector(".StyleInfo #style-error").className = "";
  }

  if (errorString !== "" || radioFlag === true) {
    if (radioFlag === true) {
      errorString += "Style Error: One or more of the required fields have not been completed<br/>"
    }
    document.querySelector(".StyleInfo #style-error").innerHTML = errorString;
    document.querySelector(".StyleInfo #style-error").className += " active";
  } else {
    document.querySelector(".StyleInfo #style-error").innerHTML = "";
    document.querySelector(".StyleInfo #style-error").className = "";
  }

  return valid
}

function handleStyleUpdate(caseSettings) {
  let groupArr = [];
  let settings = caseSettings;
  let codes = [];
  let models = [];
  let hardwareString = "";

  //Set valid to active
  settings.valid = "active";

  //Get all name attributes from the form elements
  document.querySelectorAll("#style-configurator input").forEach(element => {
    groupArr.push(element.name);
  })

  //Dedup name values
  groupArr = [...new Set(groupArr)];

  //loop through and validate each input group
  groupArr.forEach(group => {

    if (group === "analogBoards") {
      //Add the value from each board selection to the map in caseSettings
      for (let i = 0; i < settings.analogBoards.length; i += 3) {
        let total = document.querySelector("#style-configurator input#" + settings.analogBoards[i + 1]).value;
        settings.analogBoards[i + 2] = parseInt(total);
      }
    } else if (group === "ioBoards") {
      //Add the value from each board selection to the map in caseSettings
      for (let i = 0; i < settings.ioBoards.length; i += 3) {
        let total = document.querySelector("#style-configurator input#" + settings.ioBoards[i + 1]).value;
        settings.ioBoards[i + 2] = parseInt(total);
      }
    } else if (group === "commBoards") {
      //Add the value from each board selection to the map in caseSettings
      for (let i = 0; i < settings.commBoards.length; i += 3) {
        let total = document.querySelector("#style-configurator input#" + settings.commBoards[i + 1]).value;
        settings.commBoards[i + 2] = parseInt(total);
      }
    } else {
      //check that of the radio buttons from the group has been selected
      let code = document.querySelector("#style-configurator input[name=" + group + "]:checked").value;
      codes.push(code);
    }
  })

  //Set hardware styles
  let count = 1;

  for (let i = 0; i < settings.hardwareStyle.length; i++) {
    if (i === 0) {
      settings.hardwareStyle[0] = codes[0];
    } else if (i > 6) {
      settings.hardwareStyle[i] = codes[count];
      count++;
    } else {
      settings.hardwareStyle[i] = "N0"
    }
  }

  //Set all model slots back to empty
  models = ["","","","","","",""];

  //Loop through analog boards to assign a boards to each hardware slot and add the part number to the models array
  count = 1;
  for (let i = 0; i < settings.analogBoards.length; i += 3) {
    if (settings.analogBoards[i + 2] > 0) {
      for (let x = 0; x < settings.analogBoards[i + 2]; x++) {
        settings.hardwareStyle[count] = settings.analogBoards[i + 1];
        models[7 - count] = settings.analogBoards[i];
        count++;
      }
    }
  }

  //Loop through communication boards to assign a boards to the 2nd hardware slot and add the part number to the models array
  for (let i = 0; i < settings.commBoards.length; i += 3) {
    if (settings.commBoards[i + 2] > 0) {
      settings.hardwareStyle[6] = settings.commBoards[i + 1];
      models[1] = settings.commBoards[i];
    }
  }

  //Loop through power supply boards to assign a boards to the 1st hardware slot and add the part number to the models array
  for (let i = 0; i < settings.powerBoards.length; i += 2) {
    if (settings.hardwareStyle[7] === settings.powerBoards[i + 1]) {
      models[0] = settings.powerBoards[i];
    }
  }

  //Loop through I/O boards to assign a boards to each hardware slot and add the part number to the models array
  count = 5;
  for (let i = 0; i < settings.ioBoards.length; i += 3) {
    if (settings.ioBoards[i + 2] > 0) {
      for (let x = 0; x < settings.ioBoards[i + 2]; x++) {
        //Check that the hardware slot is not already taken (check 3 - 7 and then 2)
        if (settings.hardwareStyle[count] === "N0") {
          settings.hardwareStyle[count] = settings.ioBoards[i + 1];
          models[7 - count] = settings.ioBoards[i];
          count--;
        } else if (settings.hardwareStyle[6] === "N0") {
          settings.hardwareStyle[6] = settings.ioBoards[i + 1];
          models[1] = settings.ioBoards[i];
        }
      }
    }
  }

  settings.models = models

  //build hardware string for style code matching
  hardwareString = "BE1-FLEX "

  for (let i = 0; i < settings.hardwareStyle.length; i++) {
    hardwareString += settings.hardwareStyle[i]

    if (i === 0 || i === 4 || i === 5 || i === 6 || i === 9) {
      hardwareString += "-"
    } 
  }

  hardwareString += "-00"
  
  //Set style code back to default in case there isn't a match
  settings.styleCode = "BE1-FLEX ******"
  
  //Check to see if the hardware style matches a style code from the list
  for (let i = 0; i < styleMatcher.length; i += 2) {
    if (styleMatcher[i + 1] === hardwareString) {
      settings.styleCode = styleMatcher[i]
    }
  } 

  return { ...settings };
}

export { validateStyle, handleStyleUpdate };